import { createElement, Component } from 'react';
import { consumer, hydration } from '@emotion/core';
import { StyleSheet } from '@emotion/sheet';
import { isBrowser } from '@emotion/utils';
import { serializeStyles } from '@emotion/serialize';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _componentWillUnmount() {
  this.sheet.flush();
}

function _componentDidMount() {
  hydration.shouldHydrate = false;
}

function _render() {
  return consumer(this, this.renderChild);
}

var Global =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Global, _React$Component);

  function Global(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.shouldHydrate = hydration.shouldHydrate;

    function _ref(rule) {
      _this.sheet.insert(rule);
    }

    _this.renderChild = function (context) {
      var serialized = serializeStyles([_this.props.css]);

      if (_this.oldName !== serialized.name) {
        if (isBrowser) {
          _this.sheet = new StyleSheet({
            key: 'global'
          });

          _this.sheet.inject();
        }

        _this.oldName = serialized.name;
        var rules = context.stylis("", serialized.styles);
        var needsToSerializeValues = _this.serialized === undefined && _this.shouldHydrate;

        if (needsToSerializeValues) {
          _this.serialized = rules.join('');
        }

        if (isBrowser && !needsToSerializeValues) {
          _this.sheet.flush();

          _this.sheet.inject();

          rules.forEach(_ref);
        }

        if (_this.shouldHydrate && !needsToSerializeValues) {
          _this.serialized = '';
        }
      }

      if (_this.serialized !== undefined) {
        return createElement("style", {
          "data-more": "",
          dangerouslySetInnerHTML: {
            __html: _this.serialized
          }
        });
      }

      return null;
    };

    return _this;
  }

  var _proto = Global.prototype;
  _proto.componentWillUnmount = _componentWillUnmount;
  _proto.componentDidMount = _componentDidMount;
  _proto.render = _render;
  return Global;
}(Component);

Object.defineProperty(Global, "__emotion_component", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: true
});

export default Global;
//# sourceMappingURL=index.es.js.map



// WEBPACK FOOTER //
// ./node_modules/@emotion/global/dist/index.es.js